
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 19.2188H20","stroke":"#10001F","stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16 4.55228C16.3536 4.19866 16.8332 4 17.3333 4C17.581 4 17.8262 4.04877 18.0549 4.14353C18.2837 4.2383 18.4916 4.37719 18.6667 4.55228C18.8418 4.72738 18.9807 4.93525 19.0754 5.16402C19.1702 5.3928 19.219 5.638 19.219 5.88562C19.219 6.13324 19.1702 6.37844 19.0754 6.60721C18.9807 6.83599 18.8418 7.04386 18.6667 7.21895L7.55556 18.3301L4 19.219L4.88889 15.6634L16 4.55228Z","stroke":"#10001F","stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    